"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildApiCallerForAxios = void 0;
var buildApiCallerForAxios = function (axios) {
    return {
        call: axios,
        is4xxError: function (errMsg) { return errMsg.startsWith('Error: Request failed with status code 4'); },
        is5xxError: function (errMsg) { return errMsg.startsWith('Error: Request failed with status code 5'); }
    };
};
exports.buildApiCallerForAxios = buildApiCallerForAxios;
